export type ModelBackend = "ollama" | "cloudflare";

export interface ModelSelection {
  backend: ModelBackend;
  provider: string;
  model: string;
}

export const CHAT_MODEL_PREFIX = "chat-model-v1:";
export const LAST_CHAT_MODEL_KEY = "chatclient.last-chat-model";

export function encodeModelSelection(selection: ModelSelection): string {
  return `${CHAT_MODEL_PREFIX}${JSON.stringify(selection)}`;
}

export function decodeModelSelection(value: string | null): ModelSelection | null {
  if (!value || !value.startsWith(CHAT_MODEL_PREFIX)) return null;
  try {
    const parsed = JSON.parse(value.slice(CHAT_MODEL_PREFIX.length)) as Partial<ModelSelection>;
    if (
      (parsed.backend === "ollama" || parsed.backend === "cloudflare") &&
      typeof parsed.provider === "string" &&
      typeof parsed.model === "string"
    ) return parsed as ModelSelection;
  } catch {
    // Malformed or legacy values fall back to the server/default selection.
  }
  return null;
}

export function loadLastModelSelection(): ModelSelection | null {
  try { return decodeModelSelection(localStorage.getItem(LAST_CHAT_MODEL_KEY)); }
  catch { return null; }
}

export function saveLastModelSelection(selection: ModelSelection): void {
  try { localStorage.setItem(LAST_CHAT_MODEL_KEY, encodeModelSelection(selection)); }
  catch { /* Storage is a convenience, not a requirement for the current chat. */ }
}

export function clearLastModelSelection(): void {
  try { localStorage.removeItem(LAST_CHAT_MODEL_KEY); }
  catch { /* Ignore private-browsing/storage restrictions. */ }
}
